import axios from '@/load_axios';
import { API_HOST } from '@/constants';

const posts = {
    namespaced: true,
    state: {
        all: [],
        categoriesFetched: [],
    },
    getters: {
        all: (state) => (limit) => {
            let posts = []
            for (let post of state.all) {
                if (posts.length >= limit) {
                    break
                }
                posts.push(post)
            }
            return posts
        },
        category: (state) => (category, limit = null, getChildren = false) => {
            let posts = []
            let validCategories = [category.id]
            if (getChildren) {
                let children = category.children != null ? category.children : []
                validCategories = [category.id, ...children]
            }
            for (let post of state.all) {
                if (limit != null && posts.length >= limit) {
                    break
                }
                for (let categoryId of post.categories) {
                    if (validCategories.includes(categoryId)) {
                        posts.push(post)
                        break
                    }
                }
            }
            posts.sort((a, b) => {
                return (new Date(b.date)).getTime() - (new Date(a.date)).getTime()
            })
            return posts
        },
        categoryState: (state) => (id) => {
            return state.categoriesFetched.find(({ categoryId }) => {
                return categoryId == id
            })
        },
        categoryLimit: (state) => (id, limit) => {
            let posts = []
            for (let post of state.all) {
                if (posts.length >= limit) {
                    break
                }
                if (!post.categories.includes(id)) {
                    continue
                }
                posts.push(post)
            }
            return posts
        },
        id: (state) => (id) => {
            return state.all.find(post => post.id == id)
        },
        lastFromCategory: (state) => (categoryId) => {
            const posts = state.all.filter(({ categories }) => categories.includes(categoryId))
            return posts.sort((a, b) => b.date - a.date)[0]
        },
        latestFromCategory: (state) => ({ id, amount, offset }) => {
            let posts = []
            let skipped = 0
            for (let post of state.all) {
                if (skipped < offset) {
                    skipped++
                    continue
                }
                if (posts.length == amount) break
                if (!post.categories.includes(id)) continue
                posts.push(post)
            }
            return posts
        },
        slug: (state) => (slug) => {
            return state.all.find(post => post.slug == slug)
        },
    },
    mutations: {
        add(state, posts) {
            for (let post of posts) {
                const index = state.all.findIndex(storedPost => storedPost.id === post.id)
                if (index === -1) {
                    state.all.push(post)
                } else {
                    state.all.splice(index, 1, post)
                }
            }
        },
        addOne(state, post) {
            const index = state.all.findIndex(storedPost => storedPost.id === post.id)
            if (index === -1) {
                state.all.push(post)
            } else {
                state.all.splice(index, 1, post)
            }
        },
        fetchingCategory(state, category) {
            const index = state.categoriesFetched.findIndex(({ categoryId }) => {
                return categoryId == category.categoryId
            })
            if (index < 0) {
                state.categoriesFetched.push(category)
            } else {
                state.categoriesFetched.splice(index, 1, category)
            }
        },
    },
    actions: {
        async getAll({ commit }) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts`)
            console.log(res)
            commit('add', res.data)
        },
        async getCategoryById({ commit }, categoryId) {
            let params = {
                //parent_category: categoryId,
                categories: [categoryId],
                per_page: 10,
            }
            commit('fetchingCategory', { categoryId, complete: false })
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts`, { params })
            commit('add', res.data)
            commit('fetchingCategory', { categoryId, complete: true })
            return res.data
        },
        async getCategory({ commit }, category) {
            let categoryId = category.id
            let params = {
                //parent_category: categoryId,
                categories: [categoryId, ...category.children],
                per_page: 10,
            }
            commit('fetchingCategory', { categoryId, complete: false })
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts`, { params })
            // for(let child of category.children) {
            //     dispatch('getCategoryById', child)
            // }
            commit('add', res.data)
            commit('fetchingCategory', { categoryId, complete: true })
            return res.data
        },
        async getId({ commit }, id) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts/${id}`)
            commit('addOne', res.data)
            return res.data
        },
        async fetch({ commit }, slug) {
            let params = {
                slug,
            }
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts`, { params })
            commit('add', res.data)
            return res.data
        },
        async fetchById({ commit }, id) {
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts/${id}`, {
                headers: {
                    'X-WP-Nonce': window.nonce,
                }
            })
            commit('addOne', res.data)
            return res.data
        },
        async getOne({ commit }, slug) {
            let params = {
                slug,
            }
            const res = await axios.get(`${API_HOST}/wp-json/wp/v2/posts`, { params })
            commit('add', res.data)
            return res.data
        },
    },
}

export default posts
